<template>
  <div class="my">
    <div class="pc" v-if="windowWidth() > 767">
      <div class="my-left" v-if="showLeft">
        <div class="my-left-top">
          <img :src="userInfo.avatar" alt="" v-if="userInfo.avatar != ''" />
          <img src="@/assets/img/形状_16_拷贝_2.png" alt="" v-else />
          <div class="my-left-top-sf">{{ userInfo.identity }}</div>
          <div class="my-left-top-name">{{ userInfo.real_name }}</div>
          <div class="my-left-top-phone">{{ userInfo.mobile }}</div>
        </div>
        <van-sidebar v-model="activeKey" class="sidebar" style="width: 100%">
          <van-sidebar-item title="我的问题反馈" @click="sidebarChange" />
          <van-sidebar-item title="个人信息" @click="sidebarChange" />
          <van-sidebar-item title="修改密码" @click="sidebarChange" />
        </van-sidebar>
        <div class="exit" @click="exit">退出</div>
      </div>
      <div
        class="my-right"
        :style="{ 'min-width': $route.query.index ? '70%' : '1061px' }"
      >
        <router-view></router-view>
      </div>
      <a-modal
        :visible="modalVisible"
        cancelText="取消"
        okText="确定"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <p>确定退出吗？</p>
      </a-modal>
    </div>
    <div class="h5" v-else>
      <div class="h5-top">
        <div class="h5-top-left">
          <img :src="userInfo.avatar" alt="" v-if="userInfo.avatar != ''" />
          <img src="@/assets/img/图层_46.png" alt="" v-else />
        </div>
        <div class="h5-top-right">
          <div class="h5-top-right-name">{{ userInfo.real_name }}</div>
          <div class="h5-top-right-phone">{{ userInfo.mobile }}</div>
          <div class="h5-top-right-sf">
            <img src="@/assets/img/形状_1 (2).png" alt="" />
            <span>{{ userInfo.identity }}</span>
          </div>
        </div>
      </div>
      <div class="h5-list" @click="clickCard('feedbacks')">
        <img src="@/assets/img/矩形_9_拷贝_3.png" alt="" />
        <span>我的问题反馈</span>
      </div>
      <div class="h5-list" @click="clickCard('changes')">
        <img src="@/assets/img/形状_4_拷贝.png" alt="" />
        <span>修改密码</span>
      </div>
      <div class="h5-list" @click="clickCard('informations')">
        <img src="@/assets/img/矩形_12.png" alt="" />
        <span>个人信息</span>
      </div>
      <div class="h5-list" @click="LogOutOfLogin">
        <img src="@/assets/img/形状_103.png" alt="" />
        <span>退出登录</span>
      </div>
      <Tabs></Tabs>
    </div>
  </div>
</template>

<script>
import change from "./components/change.vue";
import information from "./components/information.vue";
import feedback from "./components/feedback.vue";
import Tabs from "../../components/tabs.vue";
import { $login_out, $get_user_info } from "@/api";
import { message } from "ant-design-vue";
import { mapState } from "vuex";
export default {
  components: {
    change,
    feedback,
    information,
    Tabs,
  },
  data() {
    return {
      activeKey: 0, // 侧边导航的索引
      showLeft: true,
      modalVisible: false, // 控制对话框的显示/隐藏
      userInfo: {}, // 用户信息
    };
  },
  mounted() {
    this.activeKey = this.$route.query.index;
    this.getDate();
  },
  computed: {
    ...mapState("permissions", ["isUpdate"]),
  },
  watch: {
    isUpdate() {
      console.log("my------", this.isUpdate);
      if (this.isUpdate) {
        this.getDate();
        setTimeout(() => {
          this.$store.dispatch("permissions/isUpdate", false);
        }, 1000);
      }
    },
  },
  methods: {
    // 获取数据
    async getDate() {
      try {
        let res = await $get_user_info();
        this.userInfo = res.data;
      } catch (error) {}
    },
    // 侧边导航栏切换
    sidebarChange(index) {
      let name = {
        0: "feedback",
        1: "information",
        2: "change",
      };
      this.$router.replace({
        name: name[index],
        query: { index },
      });
    },
    // 点击侧边导航栏的退出
    exit() {
      this.modalVisible = true;
    },
    // 点击退出登录的对话框的确定
    async handleOk() {
      this.modalVisible = false;
      try {
        let res = await $login_out();
        message.success("退出登录成功", 1);
        localStorage.removeItem("token");
        setTimeout(() => {
          this.$router.push({ name: "Login" });
        }, 1500);
      } catch (error) {}
    },
    // 点击退出登录的对话框的取消
    handleCancel() {
      this.modalVisible = false;
    },
    // 点击卡片 跳转到相应组件
    clickCard(name) {
      this.$router.push({ name });
    },
    // 退出登录
    async LogOutOfLogin() {
      try {
        let res = await $login_out();
        message.success("退出登录成功", 1);
        localStorage.removeItem("token");
        setTimeout(() => {
          this.$router.push({ name: "Login" });
        }, 1500);
      } catch (error) {}
    },
  },
};
</script>

<style lang="less" scoped>
// PC
@media (min-width: 767px) {
  .my {
    .pc {
      overflow: auto;
      display: flex;
      max-width: 1280px;
      // height: 961px;
      min-height: 830px;
      padding-bottom: 100px;
      margin: 0 auto;
      margin-top: 16px;

      .my-left {
        min-width: 208px;
        background: #ffffff;
        margin-right: 11px;

        .my-left-top {
          padding-top: 24px;
          padding-bottom: 29px;
          display: flex;
          flex-direction: column;
          align-items: center;
          border-bottom: 1px solid #c9c9c9;

          img {
            width: 70px;
            height: 70px;
            background: #f4f4f4;
            border-radius: 50%;
          }

          .my-left-top-sf {
            width: 62px;
            height: 19px;
            background: #f2970d;
            border-radius: 0px 10px 10px 10px;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            margin-bottom: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .my-left-top-name {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-bottom: 5px;
          }

          .my-left-top-phone {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
          }
        }

        .sidebar {
          /deep/.van-sidebar-item {
            background-color: #ffffff;
            height: 45px;
            // padding: 0;
            padding-left: 50px;
            display: flex;
            // justify-content: center;
            align-items: center;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            border-bottom: 1px solid #eeeeee;
          }

          /deep/.van-sidebar-item--select {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #e60012;
            background: #f9f9f9;
          }

          /deep/.van-sidebar-item--select::before {
            height: 70%;
            background: #e60012;
          }
        }

        .exit {
          cursor: pointer;
          background-color: #ffffff;
          height: 45px;
          padding-left: 50px;
          display: flex;
          align-items: center;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          border-bottom: 1px solid #eeeeee;
        }

        .exit:hover {
          background: #f9f9f9;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #e60012;
        }
      }

      .my-right {
        // min-width: 1061px;
        // width: 70%;
        background: #ffffff;
      }
    }
  }

  ::v-deep .ant-btn-primary {
    background-color: #e60012;
    border: none;
  }
}

// h5
@media (max-width: 767px) {
  .h5 {
    .h5-top {
      background-image: url("~@/assets/img/图层_49.png");
      display: flex;
      align-items: center;
      padding-top: 46px;
      padding-left: 25px;
      padding-bottom: 54px;
      margin-bottom: 13px;

      .h5-top-left {
        width: 65px;
        height: 65px;
        margin-right: 16px;

        img {
          border-radius: 50%;
          width: 100%;
          height: 100%;
        }
      }

      .h5-top-right {
        .h5-top-right-name {
          font-size: 17px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #1f2f4a;
          margin-bottom: 4px;
        }

        .h5-top-right-phone {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          margin-bottom: 13px;
        }

        .h5-top-right-sf {
          display: flex;
          align-items: center;

          img {
            width: 8px;
            height: 14px;
            margin-right: 6px;
          }

          span {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
          }
        }
      }
    }

    .h5-list {
      cursor: pointer;
      // width: 343px;
      width: 90%;
      height: 55px;
      background: #ffffff;
      margin: 0 auto;
      margin-bottom: 9px;
      padding: 20px;
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
        margin-right: 13px;
      }

      span {
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
      }
    }
  }
}
</style>